import { AuthConfig } from 'angular-oauth2-oidc';
import { OAuthConfig } from './config/config.model';

export function createAuthCodeFlowConfig(environment: { oauth: OAuthConfig }): AuthConfig {
  return {
    issuer: environment.oauth.issuer,
    redirectUri: environment.oauth.redirectUri,
    postLogoutRedirectUri: environment.oauth.redirectUri,
    clientId: environment.oauth.clientId,
    responseType: 'code',
    // 'organization' is required so Keycloak emits the `organization` claim (org aliases)
    // that the tenant access guard (access-check.ts) matches against tenantOrganizationAlias.
    // It is a realm default-optional scope, so every connector-ui-* client may request it.
    scope: 'openid profile email organization',
    showDebugInformation: false,
    useSilentRefresh: false,
    sessionChecksEnabled: false,
    timeoutFactor: 0.75,
    requireHttps: environment.oauth.requireHttps ?? true
  };
}
